import type { FC, ReactNode, CSSProperties } from "react";
import { Container, Box } from "@simplybusiness/mobius";

export interface ScrollableTextProps {
  /** Content to be displayed inside the scrollable section */
  children: ReactNode;
  /** Additional CSS class name */
  className?: string;
  /** Additional inline styles for the container */
  style?: CSSProperties;
}

export const ScrollableText: FC<ScrollableTextProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <Container
      className={`mobius-scrollable-text ${className || ""}`}
      style={style}
    >
      <Box className="mobius-scrollable-text__content">{children}</Box>
    </Container>
  );
};

ScrollableText.displayName = "ScrollableText";
